import script from "./LocationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationForm.vue?vue&type=script&setup=true&lang=js"

import "./LocationForm.vue?vue&type=style&index=0&id=0f2d8a26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f2d8a26"]])

export default __exports__